// (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP
var _ = require('lodash');
import {
  SAVE_USERPROFILE, UPDATE_USER_LOCATION, SESSION_LOGOUT,
  UPDATE_SIGNUP_USER_LOCATION, SAVE_USER_DATA
} from '../actions/actions';
import constants from '../Constants';

const initialState = {
  profile: null,
  position: {},
  signedUpLocation : {},
  userInfo: {}
};

const handlers = {
  [SAVE_USERPROFILE]: (state, action) => {
    // alert(action.result.profileImage)
    return {
      profile: action.result,
      position: action.result.siteLocation ? action.result.siteLocation : {}
    };
  },
  [UPDATE_USER_LOCATION]: (state, action) => {
    // let position = _.cloneDeep(state.position);
    return {
      position: action.result
    };
  },
  [SESSION_LOGOUT]: (state, action) => {
    // let position = _.cloneDeep(state.position);
    // alert('yes')
    return {
      profile: null,
      position: {}
    };
  },
  [UPDATE_SIGNUP_USER_LOCATION] : (state, action) => {
    return {
      signedUpLocation: action.result
    };
  },

  [SAVE_USER_DATA] :(state, action) => {
    return {
      userInfo : action.result
    }
  }

};

export default function userReducer(state = initialState, action) {
  let handler = handlers[action.type];
  if (!handler) return state;
  return { ...state, ...handler(state, action) };
}



// WEBPACK FOOTER //
// ./src/js/reducers/user.js